/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { createContext, ReactNode, useContext } from "react";

import { PlayerController } from "./types";

type PlayerControllerContextValue = {
  player: PlayerController;
  containerRef: React.MutableRefObject<HTMLDivElement | null>;
};

type PlayerControllerProviderProps = PlayerControllerContextValue & {
  children: ReactNode;
};

const PlayerControllerContext = createContext<PlayerControllerContextValue>(
  {} as PlayerControllerContextValue,
);

export const PlayerControllerProvider = (
  props: PlayerControllerProviderProps,
) => {
  const { player, containerRef, children } = props;

  return (
    <PlayerControllerContext.Provider value={{ player, containerRef }}>
      {children}
    </PlayerControllerContext.Provider>
  );
};

export const usePlayerController = (): PlayerControllerContextValue => {
  const context = useContext(PlayerControllerContext);

  if (!context) {
    throw new Error("Component beyond PlayerControllerContext");
  }

  return context;
};
